<template>
  <div id="app">
    <the-header />

    <app-list @showPlayer="showPlayer" />

    <youtube-player
      v-if="isPlayerShowed"
      @closePlayer="closePlayer"
      :videoId="videoId" />
  </div>
</template>

<script>
  import theHeader from './components/the-header';
  import appList from './components/app-list'
  import youtubePlayer from './components/youtube-player';

  export default {
    name: 'app',

    components: {
      theHeader,
      appList,
      youtubePlayer,
    },

    data: () => ({
      videoId: null,
      isPlayerShowed: false,
    }),

    methods: {
      showPlayer(videoId) {
        this.videoId = videoId;
        this.isPlayerShowed = true;
      },

      closePlayer() {
        this.isPlayerShowed = false;
      },
    },
  }
</script>
